import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Tabs from "../components/Tabs";
import * as settingsActions from '../../redux/actions/settings';
import AccountPageBasicSettings from "./settings/AccountPageBasicSettings.jsx";
import Button from "../components/Button.jsx";
import * as dashboardActions from "../../redux/actions/dashboard.js";
import AccountPageSharing from "./settings/AccountPageSharing.jsx";
import UserNameComponent from "../components/UserNameComponent.jsx";
import useLoggedInUser from "../hooks/useLoggedInUser.js";
import Tab from "../components/navigation/Tab.jsx";
import DevelopmentSettings from "react/pages/settings/DevelopmentSettings";
import ImportSettings from "./settings/ImportSettings.jsx";
import ImportRules from "./settings/ImportRules.jsx";
import ApiTokenSettings from "./settings/ApiTokenSettings.jsx";

export default function SettingsPage(props) {

	const dispatch = useDispatch();

	const currentActiveSettingsTab = useSelector((state) => state.url.currentActiveSettingsTab);
	const player = useLoggedInUser();

	const updateSettingsTab = (setTo) => {
		dispatch(settingsActions.settingsTabChange(setTo));
	};

	const logoutClick = (setTo) => {
		dispatch(dashboardActions.logout());
	};


	useEffect(() => {
		document.title = 'Settings!';
	}, []);

	return (
		<React.Fragment>
			<div
				className='section right-align'
			>
				{!!player.email &&
				<React.Fragment>
					Logged in as{' '}
					<UserNameComponent
						user={player}
					/>
					{' '}
					<Button
						small
						onClick={logoutClick}
					>
						Log-out
					</Button>
				</React.Fragment>
				}
				{!player.email &&
				<div className='login-warning'>
					You are not logged in, you will need to sign up to save and continue your budget!
				</div>
				}
			</div>
			<Tabs
				activeTab={currentActiveSettingsTab}
				onTabChange={updateSettingsTab}
			>
				<Tab label='Account'>
					<AccountPageBasicSettings />
				</Tab>
				<Tab label='Sharing'>
					<AccountPageSharing />
				</Tab>
				<Tab label='Import'>
					<ImportSettings />
				</Tab>
				<Tab label='Import rules'>
					<ImportRules />
				</Tab>
				<Tab label='API Tokens'>
					<ApiTokenSettings />
				</Tab>
				<Tab label='Development'>
					<DevelopmentSettings />
				</Tab>
			</Tabs>
		</React.Fragment>
	);
}